/* eslint-disable @reatom/unit-naming-rule */
import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AssetsManagementDrawer } from '@root/features/wallet/assets-management'

import { assetsDrawerOpenAtom } from '../../atoms'
import { reatomWalletAssets } from '../../atoms/reatom-wallet-assets'

import { WalletAssetsList } from './wallet-assets-list'
import { WalletAssetsSearch } from './wallet-assets-search'

import type { WalletModel } from '@root/entities/wallet/atoms'

type WalletAssetsListProps = {
  wallet: WalletModel
}

export const WalletAssets: React.FC<WalletAssetsListProps> = ({ wallet }) => {
  const [assetsDrawerOpen, setAssetsDrawerOpen] = useAtom(assetsDrawerOpenAtom)
  const model = useMemo(() => reatomWalletAssets({ wallet }), [wallet])

  return (
    <Root>
      <WalletAssetsSearch model={model} />
      <WalletAssetsList model={model} />

      <AssetsManagementDrawer
        open={assetsDrawerOpen}
        onOpenChange={setAssetsDrawerOpen}
        wallet={wallet}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  padding-top: 16px;
  padding-inline: 12px;
`
